import "./AvatarCreator.css";
import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../components/Header";

export const AvatarCreator: React.FC = () => {
  return (
    <div className="avatar-creator-content">
      <Header />
      <Outlet />
    </div>
  );
};
